import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=39a601f3&scoped=true&"
import script from "./Chip.vue?vue&type=script&lang=js&"
export * from "./Chip.vue?vue&type=script&lang=js&"
import style0 from "./Chip.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Chip.vue?vue&type=style&index=1&id=39a601f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a601f3",
  null
  
)

export default component.exports